import React, {useEffect, useLayoutEffect} from 'react'
import {useLocation} from 'react-router-dom'
import {Box} from '../../vanilla'
import {AddAllToCart} from '../add-all-to-cart'
import VoucherBanner from '../../components/voucher-banner'
import {recordVisitedPath} from '../../utils/route-history'

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect

interface IProps {
  children?: React.ReactNode
}

export const Layout = ({children}: IProps) => {
  const {pathname, search, state} = useLocation<{scrollPositionY?: number}>()

  useIsomorphicLayoutEffect(() => {
    const scrollPositionY = state?.scrollPositionY
    window.scrollTo(0, typeof scrollPositionY === 'number' ? scrollPositionY : 0)
  }, [pathname, search, state?.scrollPositionY])

  useEffect(() => {
    recordVisitedPath(`${pathname}${search}`)
  }, [pathname, search])

  return (
    <>
      <Box display="flex" flexDirection="column" flex="auto">
        <Box aria-hidden borderBottom="1px" borderColor="border1"/>
        <Box as="main" display="flex" flexDirection="column" alignItems="stretch" flex="auto">
          <VoucherBanner children={children}/>
          {children}
        </Box>
      </Box>
      <AddAllToCart/>
    </>
  )
}
